export default class DeviceService {
	constructor(apiService) {
		this.apiService = apiService
	}

	createEntity(params) {
		return this.apiService.callPost('devices', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('devices/' + id, params)
	}

	deleteDevice(id, params) {
		return this.apiService.callDelete('devices/' + id, params)
	}

	deleteEntity(id, params) {
		return this.deleteDevice(id, params);
	}

	// SEARCH
	searchDeviceTypesForRecipients(params) {
		return this.apiService.callGet('device_types_search', params)
	}

	getEntities(params) {
		return this.apiService.callGet('devices', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('devices/' + id, params)
	}

	getChannels(id) {
		return this.apiService.callGet('devices/' + id + '/channels')
	}

	getDeviceMetadata(id, params) {
		return this.apiService.callGet('devices/' + id + '/metadata', params)
	}

	restartDevices(ids, type, set = true) {
		return this.apiService.callPut('devices/restart', {
			id: ids,
			type: type,
			set: set,
		});
	}

	forceFullReloadDevices(ids, set = true) {
		return this.apiService.callPut('devices/forceFullReload', {
			id: ids,
			set: set,
		});
	}

	// MAC ADDRESS
	createMacAddress(idDevice, macAddress) {
		return this.apiService.callPost('devices/' + idDevice +'/macAddress/', macAddress);
	}

	deleteMacAddress(macAddress) {
		return this.apiService.callDelete('devices/macAddress/' + macAddress.id)
	}
}



// WEBPACK FOOTER //
// ./src/service/DeviceService.js